module.exports = __webpack_public_path__ + "media/tie.033764f9.mp3";